import React, { createContext, useContext, useState, useEffect } from "react";
import { collection, getDocs } from 'firebase/firestore';
import { ref, getDownloadURL } from 'firebase/storage';
import { db, storage } from "./firebase";

const PortfolioDataContext = createContext();

export const usePortfolioData = () => useContext(PortfolioDataContext);

export const PortfolioDataProvider = ({ children }) => {
  const [projectsData, setProjectsData] = useState(null);
  const [sideProjectsData, setSideProjectsData] = useState(null);
  const [n8nProjects, setN8nProjects] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (projectsData && sideProjectsData) {
      setLoading(false);
      return;
    }
    const fetchProjects = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'projects'));
        const projects = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const data = doc.data();
            // Get cover image URL
            const coverImageRef = ref(storage, data.coverImage);
            const coverImageUrl = await getDownloadURL(coverImageRef);

            // Get modal images URLs
            const modalImagesUrls = await Promise.all(
              data.images.map(async (imagePath) => {
                const imageRef = ref(storage, imagePath);
                const imageUrl = await getDownloadURL(imageRef);
                return imageUrl;
              })
            );
            return {
              ...data,
              coverImage: coverImageUrl,
              modalImages: modalImagesUrls,
            };
          })
        );

        const mainProjects = projects.filter(
          (project) => project.sideProject === false
        );
        const sideProjects = projects.filter(
          (project) => project.sideProject === true
        );
        const n8nProjects = projects.filter(
          (project) => project.n8n === true
        );

        console.log("Fetched projects:", { mainProjects, sideProjects, n8nProjects, raw: projects });
        
        setProjectsData(mainProjects);
        setSideProjectsData(sideProjects);
        setN8nProjects(n8nProjects);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching projects:', error);
        setLoading(false);
      }
    };

    fetchProjects();
    // eslint-disable-next-line
  }, []);

  return (
    <PortfolioDataContext.Provider value={{ projectsData, sideProjectsData, n8nProjects,loading }}>
      {children}
    </PortfolioDataContext.Provider>
  );
};
